import baseIcon from '../base.mjs';

const SiElasticstack = baseIcon("Elastic Stack", "#005571", "M1.875 0C.839 0 0 .84 0 1.875v4.792h24V1.875C24 .839 23.16 0 22.125 0zM0 8.889v6.222h24V8.89zm0 8.444v4.792C0 23.161.84 24 1.875 24h9v-6.667zm13.125 0V24h9C23.161 24 24 23.16 24 22.125v-4.792z");
const SiElasticstack$1 = SiElasticstack;

export { SiElasticstack$1 as default };
